import router, { ViewType } from '@/router'
import { routerAddQueryParam } from '../../Router/Methods/routerAddQueryParam'

export function sidebarPushLeftView(view: ViewType, rightReset?: boolean) {
  const url = routerAddQueryParam(window.history.state.current, {
    left: view ? ViewType[view] : null,
    m: null,
    ...(rightReset ? {right: null} : {}),
  })

  if (window.history.state.back === url) {
    router.back()
  } else {
    router.push(url)
  }
}
